import { Color } from "@deck.gl/core";
import { ENVIRONMENT } from "src/js/util/environment";
import { showError } from "src/js/stores/user/actions/addNotification";
import {
  ClusteredViewportSearchMapLayer,
  ClusteredViewportSearchMapLayerProps,
} from "react-migration/lib/map/layers/ClusteredViewportSearchMapLayer";
import { DesignationLayerLight } from "react-migration/domains/constraints/components/ConstraintLayer/DesignationLayer";
import { buildConstraintsTileUrl } from "react-migration/domains/constraints/components/ConstraintLayer/ConstraintLayer";
import { SimplifyProfile } from "../../ConstraintsLayerType";
import { getCachedFeatureIsVisible } from "./getCachedFeatureIsVisible";
import {
  ClusteredPermitsDocument,
  ClusteredPermitsFeatureProps,
  PermitsClusteredAggregations,
  PermitsCluster,
} from "./types";
import { PermitFilters, PermitStatusFilter } from "@landtechnologies/search-layer-contracts";

type PermitsClusteredViewportSearchMapLayerProps = Omit<
  ClusteredViewportSearchMapLayerProps<
    ClusteredPermitsDocument,
    ClusteredPermitsFeatureProps,
    PermitsClusteredAggregations,
    PermitFilters | PermitStatusFilter
  >,
  | "FeatureLayerClass"
  | "parseOpenSearchFeatures"
  | "getClusterFillColor"
  | "getClusterRadius"
  | "onFetchClusterError"
  | "renderFeatureLayers"
  | "url"
>;
export class PermitsClusteredViewportSearchMapLayer extends ClusteredViewportSearchMapLayer<
  ClusteredPermitsDocument,
  ClusteredPermitsFeatureProps,
  PermitsClusteredAggregations,
  PermitFilters | PermitStatusFilter
> {
  static layerName = "PermitsClusteredViewportSearchMapLayer";

  constructor(props: PermitsClusteredViewportSearchMapLayerProps) {
    super({
      ...props,
      url: `${ENVIRONMENT.SUPPORTING_SERVICE_URL}/permits-search-layer/clustered-viewport`,
      getClusterFillColor: getClusterFillColor,
      getClusterRadius: 25,
      renderFeatureLayers: (features) => {
        const featureIsVisible = getCachedFeatureIsVisible(features);

        return [
          new DesignationLayerLight(
            this.getSubLayerProps({
              id: `${this.props.id}-exploded-dots`,
              data: buildConstraintsTileUrl({
                rootCategory: "environmental_permits",
                designationAttributes: [],
                dedupePoints: false,
                filterAreaByZoom: false,
                simplifyProfile: SimplifyProfile.LOW,
              }),
              featureIsVisible,
              pickable: true,
            })
          ),
        ];
      },
      onFetchClusterError: (error) => {
        console.error(error);

        showError({
          id: `clustered-viewport-layer_${props.id}_search-error`,
          title: "Error searching environmental permits",
          description: "Failed to load environmental permits",
          duration: 10_000,
        });
      },
    });
  }
}

function getClusterFillColor(_: PermitsCluster): Color {
  return [78, 102, 132];
}
